import React, { FC, useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getAsset } from 'src/api/stoApi';
import { TCompleteAssetSchema } from '@brickwise/asset-validation/dist/schema/completeAsset';
import { AssetContext } from 'src/context-providers/AssetContext';
import { generalStore } from 'src/stores/GeneralStore';

const AssetRoutes: FC = () => {
  const { assetId } = useParams<{ assetId: string }>();

  if (!assetId) {
    return <></>;
  }

  const [asset, setAsset] = useState<TCompleteAssetSchema>();
  const [isEditable, setIsEditable] = useState(true);
  const [isAllowDocumentUpload, setIsAllowDocumentUpload] = useState(true);

  const fetchAsset = () => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        const response = await getAsset(assetId);
        setAsset(response.data);
        setIsEditable(
          response.data.investmentDetails.stage === 'preparing' ||
            response.data.investmentDetails.stage === 'declined' ||
            response.data.type === 'powerplantPortfolio',
        );
        setIsAllowDocumentUpload(response.data.investmentDetails.stage === 'preparing');
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };

    load();
  };

  useEffect(fetchAsset, [assetId]);

  if (!asset) {
    return <>Asset Not Found!</>;
  }

  return (
    <AssetContext.Provider value={{ asset, refreshAsset: fetchAsset, isAllowDocumentUpload, isEditable }}>
      <Outlet />
    </AssetContext.Provider>
  );
};

export default AssetRoutes;
